import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import React from 'react';

import { UseFormReturn } from 'react-hook-form';

import { AccountResponseDTO, Company, NationalNumberGroups } from '_lib/api/apiTypes.shim';

import { ExternalLink } from '_lib/components/Link/Link';
import { Typography } from '_lib/components/Typography/Typography';
import { AuthUser } from '_lib/featureComponents/auth/auth.types';
import { HeaderBox } from '_lib/featureComponents/HeaderBox/HeaderBox';
import { appRoutePaths, getFullAppRoutePath } from '_lib/featureComponents/Nav/nav.types';

import {
  CompanyConfigDetailForm,
  CompanyConfigDetailFormValues,
  companyConfigDetailFormValues
} from '../../CompanyFormItems/CompanyConfigDetailForm/CompanyConfigDetailForm';
import { FormWrapper } from '../../CompanyFormItems/FormWrapper/FormWrapper';

import { TabChangeObj } from '../CompanyUpdate';

import { useCompanyUpdateForm } from './hooks/useCompanyUpdateForm';

export type CompanyConfigDetailProps = {
  company: Company;
  account: AccountResponseDTO;
  authUser: AuthUser;
  nationalNumberGroups?: NationalNumberGroups | null;
  tabChangeObj: TabChangeObj;
};

export const CompanyConfigDetail = (props: CompanyConfigDetailProps) => {
  const { company, account, authUser, nationalNumberGroups, tabChangeObj } = props;
  const { companyUpdateFormContext, validationErrors, allErrors, handleSave, isPending } = useCompanyUpdateForm({
    company,
    authUser,
    formValuePaths: companyConfigDetailFormValues,
    tabChangeObj,
    snackMessage: 'Company saved'
  });

  return (
    <FormWrapper
      isFetchingOrPending={isPending}
      formValues={companyUpdateFormContext.getValues()}
      onSave={handleSave}
      validationErrors={validationErrors}
      allErrors={allErrors}
      disabled={!company?.isActive}>
      <HeaderBox headerText='Account' sx={{ width: 'max-content' }}>
        {!authUser.settings.callPilot.companies && <Typography text={account.name} />}
        {authUser.settings.callPilot.companies && (
          <ExternalLink
            underline='hover'
            href={`${getFullAppRoutePath(appRoutePaths.Account)}/${account.id}`}
            sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <OpenInNewIcon fontSize='small' /> {account.name}
          </ExternalLink>
        )}
      </HeaderBox>
      <CompanyConfigDetailForm
        companyConfigDetailFormContext={
          companyUpdateFormContext as unknown as UseFormReturn<CompanyConfigDetailFormValues>
        }
        company={company}
        account={account}
        nationalNumberGroups={nationalNumberGroups}
      />
    </FormWrapper>
  );
};
